export const common = {
  '--tui-safe-area-inset-top': 'env(safe-area-inset-top)',
  '--tui-safe-area-inset-right': 'env(safe-area-inset-right)',
  '--tui-safe-area-inset-bottom': 'env(safe-area-inset-bottom)',
  '--tui-safe-area-inset-left': 'env(safe-area-inset-left)'
};